<template>
  <b-navbar data-cy="navbar" toggleable="lg" class="jh-navbar">
    <b-navbar-brand class="logo" to="/">
      <img class="logo-img" src="../../../content/images/LOGO_TROPEVENT-CASH-ENTIER-WHITE.png" alt="Tropcash" />
    </b-navbar-brand>
    <select-space v-if="authenticated"></select-space>
    <b-navbar-toggle class="jh-navbar-toggler d-lg-none" target="header-tabs" aria-expanded="false" aria-label="Toggle navigation">
      <font-awesome-icon icon="bars" />
    </b-navbar-toggle>

    <b-collapse is-nav id="header-tabs">
      <b-navbar-nav class="ms-auto">
        <b-nav-item v-if="hasAnyAuthority(['ROLE_ORGA', 'ROLE_ADMIN'])" to="/" exact>
          <span>
            <font-awesome-icon icon="home" />
            <span>{{ $t('global.menu.home') }}</span>
          </span>
        </b-nav-item>
        <entities-menu></entities-menu>
        <b-nav-item-dropdown
          end
          id="admin-menu"
          v-if="hasAnyAuthority('ROLE_ADMIN') && authenticated"
          :class="{ 'router-link-active': subIsActive('/admin') }"
          active-class="active"
          class="pointer"
          data-cy="adminMenu"
        >
          <template #button-content>
            <span class="navbar-dropdown-menu">
              <font-awesome-icon icon="users-cog" />
              <span class="no-bold">{{ $t('global.menu.admin.main') }}</span>
            </span>
          </template>
          <b-dropdown-item to="/space">
            <font-awesome-icon icon="layer-group" />
            <span>{{ $t('global.menu.entities.space') }}</span>
          </b-dropdown-item>
          <b-dropdown-item to="/terminal">
            <font-awesome-icon icon="desktop" />
            <span>{{ $t('global.menu.entities.terminal') }}</span>
          </b-dropdown-item>
          <b-dropdown-item to="/location">
            <font-awesome-icon icon="map-marker-alt" />
            <span>{{ $t('global.menu.entities.location') }}</span>
          </b-dropdown-item>
          <b-dropdown-item to="/admin/user-management" active-class="active">
            <font-awesome-icon icon="users" />
            <span>{{ $t('global.menu.admin.userManagement') }}</span>
          </b-dropdown-item>
          <b-dropdown-item to="/product-child">
            <font-awesome-icon icon="cubes" />
            <span>{{ $t('global.menu.entities.productChild') }}</span>
          </b-dropdown-item>
          <b-dropdown-item to="/tva">
            <font-awesome-icon icon="percent" />
            <span>{{ $t('global.menu.entities.tva') }}</span>
          </b-dropdown-item>
          <b-dropdown-item to="/app-version">
            <font-awesome-icon icon="mobile-alt" />
            <span>{{ $t('global.menu.entities.appVersion') }}</span>
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item :to="spaceLink('nfc-card')">
            <font-awesome-icon icon="credit-card" />
            <span>{{ $t('global.menu.entities.card') }}</span>
          </b-dropdown-item>
          <b-dropdown-item :to="spaceLink('app-action-sync')">
            <font-awesome-icon icon="sync" />
            <span>{{ $t('global.menu.entities.appActionSync') }}</span>
          </b-dropdown-item>
          <b-dropdown-item :to="spaceLink('cash-order-sync')">
            <font-awesome-icon icon="exchange-alt" />
            <span>{{ $t('global.menu.entities.cashOrderSync') }}</span>
          </b-dropdown-item>
          <b-dropdown-item :to="spaceLink('access-population-sync')">
            <font-awesome-icon icon="users" />
            <span>{{ $t('global.menu.entities.accessPopulationSync') }}</span>
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item to="/admin/jobs" active-class="active">
            <font-awesome-icon icon="sync" />
            <span>{{ $t('global.menu.admin.jobs') }}</span>
          </b-dropdown-item>
          <b-dropdown-item to="/admin/alarms" active-class="active">
            <font-awesome-icon icon="exclamation-triangle" />
            <span>{{ $t('global.menu.admin.alarm') }}</span>
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item to="/audit">
            <font-awesome-icon icon="history" />
            <span>{{ $t('global.menu.entities.audit') }}</span>
          </b-dropdown-item>
          <b-dropdown-item to="/admin/metrics" active-class="active">
            <font-awesome-icon icon="tachometer-alt" />
            <span>{{ $t('global.menu.admin.metrics') }}</span>
          </b-dropdown-item>
          <b-dropdown-item to="/admin/health" active-class="active">
            <font-awesome-icon icon="heart" />
            <span>{{ $t('global.menu.admin.health') }}</span>
          </b-dropdown-item>
          <b-dropdown-item to="/admin/configuration" active-class="active">
            <font-awesome-icon icon="cogs" />
            <span>{{ $t('global.menu.admin.configuration') }}</span>
          </b-dropdown-item>
          <b-dropdown-item to="/admin/logs" active-class="active">
            <font-awesome-icon icon="tasks" />
            <span>{{ $t('global.menu.admin.logs') }}</span>
          </b-dropdown-item>
          <b-dropdown-item v-if="openAPIEnabled" to="/admin/docs" active-class="active">
            <font-awesome-icon icon="book" />
            <span>{{ $t('global.menu.admin.apidocs') }}</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item to="/faq">
          <span>
            <font-awesome-icon icon="question-circle" />
            <span class="no-bold">FAQ</span>
          </span>
        </b-nav-item>
        <b-nav-item-dropdown
          end
          id="account-menu"
          :class="{ 'router-link-active': subIsActive('/account') }"
          active-class="active"
          class="pointer"
          data-cy="accountMenu"
        >
          <template #button-content>
            <span class="navbar-dropdown-menu">
              <font-awesome-icon icon="user" />
              <span class="no-bold">{{ $t('global.menu.account.main') }}</span>
            </span>
          </template>
          <b-dropdown-item data-cy="settings" to="/account/settings" v-if="authenticated" active-class="active">
            <font-awesome-icon icon="wrench" />
            <span>{{ $t('global.menu.account.settings') }}</span>
          </b-dropdown-item>
          <b-dropdown-item data-cy="passwordItem" to="/account/password" v-if="authenticated" active-class="active">
            <font-awesome-icon icon="lock" />
            <span>{{ $t('global.menu.account.password') }}</span>
          </b-dropdown-item>
          <template v-if="languages && Object.keys(languages).length > 1">
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item
              v-for="(value, key) in languages"
              :key="`lang-${key}`"
              @click="changeLanguage(key)"
              :class="{ active: isActiveLanguage(key) }"
            >
              <font-awesome-icon icon="flag" :class="{ 'lang-active-flag': isActiveLanguage(key) }" />
              <span>{{ value.name }}</span>
            </b-dropdown-item>
          </template>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item data-cy="logout" v-if="authenticated" @click="logout()" id="logout" active-class="active">
            <font-awesome-icon icon="sign-out-alt" />
            <span>{{ $t('global.menu.account.logout') }}</span>
          </b-dropdown-item>
          <b-dropdown-item data-cy="login" v-if="!authenticated" @click="openLogin()" id="login" active-class="active">
            <font-awesome-icon icon="sign-in-alt" />
            <span>{{ $t('global.menu.account.login') }}</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script lang="ts" src="./jhi-navbar.component.ts"></script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* ==========================================================================
    Navbar
    ========================================================================== */
.navbar-version {
  font-size: 10px;
  color: #ccc;
}

.jh-navbar {
  background-color: #353d47;
  padding: 0.2em 1em;
}

.jh-navbar .profile-image {
  margin: -10px 0px;
  height: 40px;
  width: 40px;
  border-radius: 50%;
}

.jh-navbar .dropdown-item.active,
.jh-navbar .dropdown-item.active:focus,
.jh-navbar .dropdown-item.active:hover {
  background-color: #353d47;
}

.jh-navbar .dropdown-toggle::after {
  margin-left: 0.15em;
}

.jh-navbar ul.navbar-nav {
  padding: 0.5em;
}

.jh-navbar a.nav-link,
.jh-navbar .no-bold {
  font-weight: 400;
}

/* Réplique le theming `navbar-dark` (prop bootstrap-vue disparue en bootstrap-vue-next) : liens navbar en texte clair.
   `:deep()` est nécessaire car les .nav-link sont rendus par les composants enfants <b-nav-item> (le style scoped ne
   les atteint pas sinon). On cible uniquement les liens/toggles — surtout PAS `data-bs-theme="dark"` sur la navbar,
   qui cascaderait et rendrait aussi les menus déroulants sombres (ils doivent rester blancs, comme en prod). */
.jh-navbar :deep(.navbar-nav .nav-link) {
  color: rgba(255, 255, 255, 0.55);
}
.jh-navbar :deep(.navbar-nav .nav-link:hover),
.jh-navbar :deep(.navbar-nav .nav-link:focus) {
  color: rgba(255, 255, 255, 0.75);
}
.jh-navbar :deep(.navbar-nav .nav-link.active),
.jh-navbar :deep(.navbar-nav .show > .nav-link),
.jh-navbar :deep(.navbar-nav .router-link-active > .nav-link) {
  color: #fff;
}

.jh-navbar .jh-navbar-toggler {
  color: #ccc;
  font-size: 1.5em;
  padding: 10px;
}

.jh-navbar .jh-navbar-toggler:hover {
  color: #fff;
}

@media screen and (min-width: 992px) {
  .jh-navbar-toggler {
    display: none;
  }
}

@media screen and (min-width: 992px) and (max-width: 1199px) {
  .jh-navbar .nav-link > span,
  .jh-navbar .navbar-dropdown-menu {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
  }
  .jh-navbar .navbar-dropdown-menu .no-bold::after {
    display: inline-block;
    margin-left: 0.25em;
    vertical-align: 0.2em;
    content: '';
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }
}

.navbar-title {
  display: inline-block;
  vertical-align: middle;
  color: white;
}

/* ==========================================================================
    Logo styles
    ========================================================================== */
.navbar-brand.logo {
  padding: 5px 15px;
}

.logo .logo-img {
  height: 50px;
  display: inline-block;
  vertical-align: middle;
  width: auto;
}
</style>
